// 子路由要渲染到父路由的<router-view />中
const RouteView = {
  name: "RouteView",
  render: (h) => h("router-view"),
};
// 定义页面路由
const constantRouterComponents = {
  // 登陆
  Login: () => import("@/views/login"),
  // 工地管理
  BasicLayout: () => import("@/layouts/BasicLayout"),
  SiteMap: () => import("@/views/site/SiteMap.vue"), // 施工地图
  CustomMap: () => import("@/views/site/CustomMap.vue"), //定制地图
  SiteList: () => import("@/views/site/SiteList.vue"), // 工地列表
  SiteSuspend: () => import("@/views/site/SiteSuspend.vue"), // 暂停施工
  SitePreview: () => import("@/views/site/SitePreview.vue"), // 直播
  SiteSnapshot: () => import("@/views/site/SiteSnapshot.vue"), // 快照
  SitePlayback: () => import("@/views/site/SitePlayback.vue"), // 回放
  SiteAttend: () => import("@/views/site/SiteAttend.vue"), // 考勤
  // 员工管理
  WorkerList: () => import("@/views/worker/WorkerList.vue"), // 人员列表
  WorkerAttend: () => import("@/views/worker/WorkerAttend.vue"), // 人员考勤
  WorkerAttendStatistics: () =>
    import("@/views/worker/WorkerAttendStatistics.vue"), // 人员考勤统计
  // 设备管理
  DeviceList: () => import("@/views/device/DeviceList.vue"), // 设备列表
  DeviceStock: () => import("@/views/device/DeviceStock.vue"), // 设备导入
  DeviceStatistics: () => import("@/views/device/DeviceStatistics.vue"), //设备统计
  // 工地形象
  AlarmEvent: () => import("@/views/image/AlarmEvent.vue"), // 报警事件
  SiteNeat: () => import("@/views/image/SiteNeat.vue"), // 整洁管理
  CorrectionLog: () => import("@/views/image/CorrectionLog.vue"), // 纠正日志
  // 权限管理
  RoleList: () => import("@/views/role/RoleList.vue"), // 角色权限
  UserList: () => import("@/views/role/UserList.vue"), // 用户权限
  Organization: () => import("@/views/role/OrganizatAdmin.vue"), //组织管理
  PersonalizedView: () => import("@/views/role/PersonalizedView.vue"), //个性化设置
  MenuList: () => import("@/views/role/MenuList.vue"), //页面设置
  // 库存与订单管理
  // DeviceStockList: () => import("@/views/stockAndOrder/deviceStockList.vue"), // 库存管理
  // 日报
  DailyList: () => import("@/views/site/daily/DailyList.vue"),
  SampleSite: () => import("@/views/site/SampleSite.vue"),
  // ExhibitionBboard: () => import("@views/exhibitionboard/ExhibitionBoard.vue"), //展厅看板
  // 数据统计
  DailySheet: () => import("@/views/dataStatistics/DailySheet.vue"),
  SiteImage: () => import("@/views/dataStatistics/SiteImage.vue"), //工地形象统计
  AttendStatistics: () => import("@/views/dataStatistics/AttendStatistics.vue"), //考勤统计
};

export const asyncRouterMap = [
  // 数据看板
  {
    path: "/data",
    name: "data",
    meta: { title: "数据看板", icon: "fund" },
    // component: RouteView,
    component: () => import("@/views/data/DailyMonitor.vue"),
    children: [
      {
        path: "/DailyMonitor",
        name: "DailyMonitor",
        meta: { title: "数据看板", showMenu: false },
        component: () => import("@/views/data/DailyMonitor.vue"),
      },
      {
        path: "/DataV",
        name: "DataV",
        // meta: { title: "AI数据可视化看板", showMenu: true },
        meta: { title: "AI可视化看板", showMenu: false },
        component: () => import("@/views/datav/index.vue"),
      },
      {
        path: "/Patrol",
        name: "Patrol",
        // meta: { title: "现场可视化看板-巡查", showMenu: true },
        meta: { title: "工地巡查大屏", showMenu: false },
        component: () => import("@/views/inspection/index.vue"),
      },
      // {
      //   path: "/Inspect",
      //   name: "Inspect",
      //   meta: { title: "现场可视化看板-巡查", showMenu: true },
      //   component: () => import("@/views/inspection/index.vue"),
      // },
      {
        path: "/CaseField",
        name: "CaseField",
        // meta: { title: "现场可视化看板-案场", showMenu: true },
        meta: { title: "工地案场", showMenu: false },
        component: () => import("@/views/caseField/index.vue"),
      },
      // 菜单栏是否显示
      {
        path: "/customPreview",
        name: "customPreview", //和给后端的一样
        meta: { title: "定制案场", showMenu: false },
        component: () => import("@/views/customField/customPreview.vue"),
      },
      {
        path: "/BoardTotal",
        name: "BoardTotal",
        meta: { title: "管理端看板", showMenu: false },
        component: () => import("@/views/adminBoard/BoardTotal.vue"),
      },
      {
        path: "/ExhibitionBoard",
        name: "ExhibitionBoard",
        meta: { title: "展厅数据看板", showMenu: false },
        component: () => import("@/views/exhibitionboard/ExhibitionBoard.vue"),
      },
      {
        path: "/ExhibitionBoard2",
        name: "ExhibitionBoard2",
        meta: { title: "展厅数据看板", showMenu: false },
        component: () => import("@/views/exhibitionboard2/ExhibitionBoard.vue"),
      },
      {
        path: "/MapFieldboard",
        name: "MapFieldboard",
        meta: { title: "地图案场看板", showMenu: false },
        component: () => import("@/views/mapField"), //
      },
      {
        path: "/VideoRecord",
        name: "VideoRecord",
        meta: { title: "展厅直播", showMenu: false },
        component: () => import("@/views/videoRecord"),
      },
    ],
  },
  // 工地管理
  {
    path: "/Site",
    name: "Site",
    meta: { title: "工地管理", icon: "schedule" },
    component: RouteView,
    redirect: "/SiteMap",
    children: [
      {
        path: "/SiteList",
        name: "SiteList",
        meta: { title: "工地列表", showMenu: true },
        component: constantRouterComponents.SiteList,
      },
      {
        path: "/SiteMap",
        name: "SiteMap",
        meta: { title: "施工地图", showMenu: true },
        component: constantRouterComponents.SiteMap,
      },
      // {
      //   path: "/CustomMap",
      //   name: "CustomMap",
      //   meta: { title: "定制地图", showMenu: true },
      //   component: constantRouterComponents.CustomMap,
      // },

      {
        path: "/SiteSuspend",
        name: "SiteSuspend",
        meta: { title: "暂停施工", showMenu: true },
        component: constantRouterComponents.SiteSuspend,
      },
      {
        path: "/DailyList",
        name: "DailyList",
        meta: { title: "日报管理", showMenu: true },
        component: constantRouterComponents.DailyList,
      },
      {
        path: "/SampleSite",
        name: "SampleSite",
        meta: { title: "样板工地管理", showMenu: true },
        component: constantRouterComponents.SampleSite,
      },
    ],
  },
  // 人员管理
  {
    path: "/Worker",
    name: "Worker",
    meta: { title: "人员管理", icon: "team" },
    component: RouteView,
    children: [
      {
        path: "/WorkerAttend",
        name: "WorkerAttend",
        meta: { title: "人员考勤", showMenu: true },
        component: constantRouterComponents.WorkerAttend,
      },
      {
        path: "/WorkerList",
        name: "WorkerList",
        meta: { title: "人员列表", showMenu: true },
        component: constantRouterComponents.WorkerList,
      },

      {
        path: "/WorkerAttendStatistics",
        name: "WorkerAttendStatistics",
        meta: { title: "人员考勤统计", showMenu: true },
        component: constantRouterComponents.WorkerAttendStatistics,
      },
    ],
  },
  // 工地形象
  {
    path: "/image",
    name: "image",
    meta: { title: "工地形象", icon: "pic-right" },
    component: RouteView,
    children: [
      {
        path: "/AlarmEvent",
        name: "AlarmEvent",
        meta: { title: "报警事件管理", showMenu: true },
        component: constantRouterComponents.AlarmEvent,
      },
      {
        path: "/SiteNeat",
        name: "SiteNeat",
        meta: { title: "整洁管理", showMenu: true },
        component: constantRouterComponents.SiteNeat,
      },
      {
        path: "/CorrectionLog",
        name: "CorrectionLog",
        meta: { title: "纠正日志", showMenu: true },
        component: constantRouterComponents.CorrectionLog,
      },
    ],
  },
  // 数据统计
  {
    path: "/dataStatistics",
    name: "dataStatistics",
    meta: { title: "数据统计", icon: "bar-chart" },
    component: RouteView,

    children: [
      {
        path: "/DailySheet",
        name: "DailySheet",
        meta: { title: "日报", showMenu: true },
        component: constantRouterComponents.DailySheet,
      },
      {
        path: "/AttendStatistics",
        name: "AttendStatistics",
        meta: { title: "考勤统计", showMenu: true },
        component: constantRouterComponents.AttendStatistics,
      },
      {
        path: "/SiteImage",
        name: "SiteImage",
        meta: { title: "工地形象统计", showMenu: true },
        component: constantRouterComponents.SiteImage,
      },
    ],
  },

  //设备管理
  {
    path: "/device",
    name: "device",
    meta: { title: "设备管理", icon: "printer" },
    component: RouteView,
    children: [
      {
        path: "/DeviceList",
        name: "DeviceList",
        meta: { title: "设备列表", showMenu: true },
        component: constantRouterComponents.DeviceList,
      },
      {
        path: "/DeviceStock",
        name: "DeviceStock",
        meta: { title: "设备库存", showMenu: true },
        component: constantRouterComponents.DeviceStock,
      },

      {
        path: "/DeviceStatistics",
        name: "DeviceStatistics",
        meta: { title: "设备统计", showMenu: true },
        component: constantRouterComponents.DeviceStatistics,
      },
    ],
  },
  // 权限管理
  {
    path: "/role",
    name: "role",
    meta: { title: "权限管理", icon: "audit" },
    component: RouteView,
    children: [
      {
        path: "/UserList",
        name: "UserList",
        meta: { title: "用户权限", showMenu: true },
        component: constantRouterComponents.UserList,
      },
      {
        path: "/RoleList",
        name: "RoleList",
        // meta: { title: "角色权限", showMenu: true },
        meta: { title: "角色管理", showMenu: true },
        component: constantRouterComponents.RoleList,
      },
      {
        path: "/Organization",
        name: "Organization",
        meta: { title: "组织管理", showMenu: true },
        component: constantRouterComponents.Organization,
      },

      {
        path: "/PersonalizedView",
        name: "PersonalizedView",
        meta: { title: "个性化设置", showMenu: true },
        component: constantRouterComponents.PersonalizedView,
      },
      {
        path: "/MenuList",
        name: "MenuList",
        meta: { title: "页面设置", showMenu: true },
        component: constantRouterComponents.MenuList,
      },
    ],
  },

  // {
  //   path: "/stockAndOrder",
  //   name: "stockAndOrder",
  //   meta: { title: "库存与订单", icon: "pic-right" },
  //   component: RouteView,
  //   children: [
  //     {
  //       path: "/deviceStockList",
  //       name: "DeviceStockList",
  //       meta: { title: "库存管理", showMenu: true },
  //       // component: () => import("@/views/stockAndOrder/deviceStockList.vue"),
  //     },
  //   ],
  // },
];

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: "/",
    name: "BasicLayout",
    component: constantRouterComponents.BasicLayout,
    redirect: "/Login",
    children: asyncRouterMap,
  },
  {
    path: "/Login",
    name: "Login",
    component: constantRouterComponents.Login,
  },
  {
    path: "/DataView",
    name: "DataView",
    component: () => import("@/views/datav/index.vue"),
  },
  {
    path: "/PatrolView",
    name: "PatrolView",
    component: () => import("@/views/inspection/index.vue"),
  },
  {
    path: "/PatrolDetail",
    name: "PatrolView",
    component: () => import("@/views/inspection/detail.vue"),
  },
  // {
  //   path: "/Inspection",
  //   name: "Inspection",
  //   component: () => import("@/views/inspection/index.vue"),
  // },
  {
    path: "/CaseFieldView",
    name: "CaseFieldView",
    component: () => import("@/views/caseField/index.vue"),
  },
  {
    path: "/404",
    component: () =>
      import(/* webpackChunkName: "fail" */ "@/views/exception/404"),
  },
  {
    path: "/500",
    component: () =>
      import(/* webpackChunkName: "fail" */ "@/views/exception/500"),
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
  {
    path: "/customPreviewView",
    name: "customPreviewView",
    component: () => import("@/views/customField/customPreview.vue"),
  },
  {
    path: "/BoardTotalView",
    name: "BoardTotalView",
    component: () => import("@/views/adminBoard/BoardTotal.vue"),
  },
  {
    path: "/ExhibitionBoardView",
    name: "ExhibitionBoardView",
    component: () => import("@/views/exhibitionboard/ExhibitionBoard.vue"),
  },
  {
    path: "/ExhibitionBoardView2",
    name: "ExhibitionBoardView2",
    component: () => import("@/views/exhibitionboard2/ExhibitionBoard.vue"),
  },
  {
    path: "/MapFieldboardView",
    name: "MapFieldboard",
    component: () => import("@/views/mapField"),
  },
  {
    path: "/VideoRecordView",
    name: "videoRecord",
    component: () => import("@/views/videoRecord"),
  },
];
